//--------------------------------------------------
//Rendered Component when opening website for the first time
//--------------------------------------------------

import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { ProjectModal, Sidebar, NavigationBar } from '../GeneralComponents';
import { Container, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';

import leftButton from '../../Images/left-button.svg'
import rightButton from '../../Images/right-button.svg'

import KRAKEN1 from '../../Images/Projects/KRAKEN1.png'
import KRAKEN2 from '../../Images/Projects/KRAKEN2.PNG'
import KRAKEN3 from '../../Images/Projects/KRAKEN3.PNG'
import KRAKEN4 from '../../Images/Projects/KRAKEN4.PNG'

import Teleport1 from '../../Images/Projects/Teleport1.PNG'
import Teleport2 from '../../Images/Projects/Teleport2.PNG'
import Teleport3 from '../../Images/Projects/Teleport3.PNG'
import Teleport4 from '../../Images/Projects/Teleport4.PNG'

import TVWH1 from '../../Images/Projects/TVWH.PNG'
import TVWH2 from '../../Images/Projects/TVWH2.PNG'
import TVWH3 from '../../Images/Projects/TVWH3.PNG'
import TVWH4 from '../../Images/Projects/TVWH4.PNG'

import IdaGem from '../../Images/Projects/IdaGem.PNG'
import IdaGem2 from '../../Images/Projects/IdaGem2.PNG'
import IdaGem3 from '../../Images/Projects/IdaGem3.PNG'
import IdaGem4 from '../../Images/Projects/IdaGem4.PNG'

import VentureCollege from '../../Images/Projects/VentureCollege.PNG'
import VentureCollege2 from '../../Images/Projects/VentureCollege2.PNG'
import VentureCollege3 from '../../Images/Projects/VentureCollege3.PNG'

import FATE1 from '../../Images/Projects/FATE.png'

import DrumDuel from '../../Images/Projects/DrumDuel.PNG'

import SnS from '../../Images/Projects/SnS.PNG'

import Agent131 from '../../Images/Projects/Agent13.PNG'

import MINUS1 from '../../Images/Projects/MINUS.png'

import resume from '../../Files/JC_Ho_Resume.pdf'

import AWS from '../../Images/SkillsIcons/AWS.png'
import CSharp from '../../Images/SkillsIcons/CSharp.png'
import CSS from '../../Images/SkillsIcons/CSS.png'
import HTML from '../../Images/SkillsIcons/HTML.png'
import Java from '../../Images/SkillsIcons/Java.png'
import JavaScript from '../../Images/SkillsIcons/JavaScript.png'
import TypeScript from '../../Images/SkillsIcons/Typescript.png'
import MySQL from '../../Images/SkillsIcons/MySQL.png'
import PostgreSQL from '../../Images/SkillsIcons/PostgreSQL.png'
import Node from '../../Images/SkillsIcons/Node.png'
import ReactLogo from '../../Images/SkillsIcons/React.png'
import VueLogo from '../../Images/SkillsIcons/Vue.png'
import Rust from '../../Images/SkillsIcons/Rust.png'
import Unity from '../../Images/SkillsIcons/Unity.svg'
import Unreal from '../../Images/SkillsIcons/Unreal.svg'

const skills = [
    { name: "AWS", image: AWS },
    { name: "Rust", image: Rust },
    { name: "MySQL", image: MySQL },
    { name: "PostgreSQL", image: PostgreSQL },
    { name: "HTML", image: HTML },
    { name: "CSS", image: CSS },
    { name: "JavaScript", image: JavaScript },
    { name: "TypeScript", image: TypeScript },
    { name: "Node.js", image: Node },
    { name: "React.js", image: ReactLogo },
    { name: "Vue.js", image: VueLogo },
    { name: "Java", image: Java },
    { name: "C#", image: CSharp },
    { name: "Unity", image: Unity },
    { name: "Unreal Engine", image: Unreal },
];

// TEMPLATE
// { name: '', images: [], description: '', type: '', role: '', date: '', video: '' },

let projects = [
    { name: 'KRAKEN', images: [KRAKEN1, KRAKEN2, KRAKEN3, KRAKEN4], description: '3D print farm management software with a functional and simple GUI.', type: 'Software', role: 'Software Developer', date: '2025-2026', video: '' },
    { name: 'Teleport', images: [Teleport1, Teleport2, Teleport3, Teleport4], description: 'Online marketplace connection tool for 3D printing fulfillment.', type: 'Software', role: 'Software Developer', date: '2025-2026', video: '' },
    { name: 'Treasure Valley Water Hub', images: [TVWH1, TVWH2, TVWH3, TVWH4], description: 'A React website to bring all Treasure Valley water data, tools, and maps into one place for easy accessibility and use.', type: 'Website', role: 'Full Stack Developer', date: 'SUMMER 2024', video: '' },
    { name: 'IdaGem', images: [IdaGem, IdaGem2, IdaGem3, IdaGem4], description: 'A learning website with a Unity game attached for students in Idaho.', type: 'Website', role: 'Back-End Developer', date: 'SUMMER 2024', video: '' },
    { name: 'Venture College', images: [VentureCollege, VentureCollege2, VentureCollege3], description: 'A website developed for judges to be able to have a place to leave scores and comments on groups and teams in large competitions.', type: 'Website', role: 'Back-End Developer', date: 'SPRING 2025', video: '' },
    { name: 'F.A.T.E.', images: [FATE1], description: "A React website created for teachers to rate other academic professional's portfolios.", type: 'Website', role: 'Front-End Developer', date: 'SPRING 2024', video: '' },
    { name: 'ULT MINUS', images: [MINUS1], description: 'A casual competitive mod created by me for Smash Ultimate.', type: 'Game Mod', role: 'Dev Lead', date: '2024-2025', video: 'https://www.youtube.com/embed/KGJBI8S4_wE?si=eOOi3CcxjvIYxY4M' },
    { name: 'Drum Duel', images: [DrumDuel], description: 'An accessible arcade multiplayer drum rhythm game made in Unreal Engine.', type: 'Game', role: 'Game Developer', date: 'FALL 2024', video: 'https://www.youtube.com/embed/ca9De-QWJcY?si=GzGVGAwO0XZStALY' },
    { name: `Slurgin N' Snop`, images: [SnS], description: 'A networked multiplayer game about a Snail and a Slug working together made in Unreal Engine.', type: 'Game', role: 'Game Developer', date: 'FALL 2024', video: 'https://www.youtube.com/embed/yASwTYEKEWs?si=C4pjmV0bXGz3ML1h' },
    { name: 'Agent 13', images: [Agent131], description: 'A Unity VR Action/Stealth game.', role: 'Game Developer', date: 'FALL 2023-SPRING 2024', type: 'VR Game', video: 'https://www.youtube.com/embed/3_IecVpGBtg?si=STVaxKPOhgOAt7b1' },
]

const Home = ({ aboutRef, projectRef, resumeRef }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState({ name: '', images: [], video: '' });
    const [swiperInstance, setSwiperInstance] = useState(null);

    const scrollToRef = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSlideClick = (project) => {
        setSelectedProject(project);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <Fragment>
            <NavigationBar scrollToRef={scrollToRef} aboutRef={aboutRef} projectRef={projectRef} resumeRef={resumeRef} />
            <Sidebar scrollToRef={scrollToRef} aboutRef={aboutRef} projectRef={projectRef} resumeRef={resumeRef} />
            <Container fluid className='home'>
                { /* ABOUT SECTION */}
                <br />
                <div className='about-section' ref={aboutRef}>
                    <div className='bubble1'>
                        <div className='skills-bubble'>
                            <h2>Skills</h2>
                            <hr />
                            <div className='logo-container'>
                                {skills.map((skill, i) =>
                                    <div key={i} className='skill-logo-container'>
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{skill.name}</Tooltip>}>
                                            <img src={skill.image} alt={skill.name} className='skill-logo' />
                                        </OverlayTrigger>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='text-bubble'>
                        <div className='text-bubble-container'>
                            <h1>About Me</h1>
                            <hr className='bubble-hr'></hr>
                            <p>
                                Hello! I am JC Ho! I am a Software/Web Developer. I have a B.S. in Games Interactive Media and Mobile from Boise State University. I have had around 2 years of professional dev work both on a development team at Boise State as a student and as a developer at a startup called Slant 3D. I have been working Full Stack in both areas diving into many different fields of development and working on many complex and creative projects. I have also worked on many games and my own game mods. Please explore my website to learn more!
                            </p>
                        </div>
                    </div>
                </div>

                { /* PROJECT SECTION */}
                <Row className='justify-content-center project-section' ref={projectRef}>
                    <h1>Projects</h1>
                    <hr className='section-hr'></hr>
                    <Swiper
                        className='project-swiper'
                        modules={[Navigation, Autoplay]}
                        navigation={{
                            nextEl: '.next',
                            prevEl: '.prev',
                        }}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: true,
                        }}
                        slidesPerView={2}
                        setWrapperSize={false}
                        spaceBetween={50}
                        loop={true}
                        onSwiper={(swiper) => setSwiperInstance(swiper)}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 35,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 50,
                            },
                        }}>

                        {projects.map((project, index) => (
                            <SwiperSlide key={index} className='slide' onClick={() => handleSlideClick(project)} onMouseEnter={() => swiperInstance?.autoplay.stop()} onMouseLeave={() => swiperInstance?.autoplay.start()}>
                                <h1 className='project-title'>{project.name}</h1>
                                <img src={project.images[0]} alt='Project Thumbnail' />
                                <p className='description'>{project.description}</p>
                                <div className='extra-details'>
                                    <p><b>Type</b> <br /> {project.type}</p>
                                    <p><b>Role</b> <br /> {project.role}</p>
                                    <p><b>Date</b> <br /> {project.date}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className='swiper-buttons'>
                        <img className="prev" src={leftButton} alt='Left Button'></img>
                        <img className="next" src={rightButton} alt='Right Button'></img>
                    </div>

                    {showModal && (
                        <ProjectModal
                            name={selectedProject.name}
                            images={selectedProject.images}
                            video={selectedProject.video}
                            show={showModal}
                            handleClose={handleClose}
                        />
                    )}
                </Row>

                { /* RESUME SECTION */}
                <Row className='justify-content-center resume-section' ref={resumeRef}>
                    <h1>Resume</h1>
                    <hr className='section-hr'></hr>
                    <iframe className='resume' src={resume} title='Resume'></iframe>
                </Row>
                <br />
            </Container>
        </Fragment>
    )
};

function mapState(state) {
    const { session } = state;
    return { session };
}

const actionCreators = {
};

const connection = connect(mapState, actionCreators)(Home);
export { connection as Home };